// Session tracking utilities for logout stats

// Initialize session on login
export const initializeSession = () => {
  localStorage.setItem('jani-login-time', new Date().toISOString());
  localStorage.setItem('jani-pages-visited', '1');
  localStorage.setItem('jani-actions-count', '0');
};

// Track page visit
export const trackPageVisit = () => {
  const current = parseInt(localStorage.getItem('jani-pages-visited') || '0', 10);
  localStorage.setItem('jani-pages-visited', String(current + 1));
};

// Track action (button clicks, form submissions, etc.)
export const trackAction = () => {
  const current = parseInt(localStorage.getItem('jani-actions-count') || '0', 10);
  localStorage.setItem('jani-actions-count', String(current + 1));
};

// Get session stats
export const getSessionStats = () => {
  const loginTime = localStorage.getItem('jani-login-time');
  const pagesVisited = parseInt(localStorage.getItem('jani-pages-visited') || '1', 10);
  const actionsPerformed = parseInt(localStorage.getItem('jani-actions-count') || '0', 10);

  let durationMinutes = 0;
  if (loginTime) {
    const loginDate = new Date(loginTime);
    const now = new Date();
    durationMinutes = Math.floor((now.getTime() - loginDate.getTime()) / 60000);
  }

  return {
    loginTime,
    pagesVisited,
    actionsPerformed,
    durationMinutes,
  };
};

// Clear session data (called after logout animation)
export const clearSession = () => {
  localStorage.removeItem('jani-login-time');
  localStorage.removeItem('jani-pages-visited');
  localStorage.removeItem('jani-actions-count');
};
